import { PaymentConditionFilter } from '../../types/models/payment-condition/payment-condition-filter'

export const transformPaymentConditionFiltersToUrl = (
  filters?: PaymentConditionFilter
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))

  return searchParams.toString()
}

export const transformUrlToPaymentConditionFilters = (
  searchParams: URLSearchParams
): PaymentConditionFilter => {
  const filters: PaymentConditionFilter = {}

  const countries = searchParams.get('countries')
  if (countries) filters.countries = countries.split(',').map((id) => +id)

  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',').map((id) => +id)

  return filters
}
